/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RenewalStatus = {
    NotInitialized: 'NOT_INITIALIZED',
    PendingDecision: 'PENDING_DECISION',
    Declined: 'DECLINED',
    AwaitingQuote: 'AWAITING_QUOTE',
    ToApprove: 'TO_APPROVE',
    Renewed: 'RENEWED',
    RefusedByFreelancer: 'REFUSED_BY_FREELANCER',
    RefusedByClient: 'REFUSED_BY_CLIENT'
} as const;
export type RenewalStatus = typeof RenewalStatus[keyof typeof RenewalStatus];


export function instanceOfRenewalStatus(value: any): boolean {
    for (const key in RenewalStatus) {
        if (Object.prototype.hasOwnProperty.call(RenewalStatus, key)) {
            // @ts-ignore
            if (RenewalStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RenewalStatusFromJSON(json: any): RenewalStatus {
    return RenewalStatusFromJSONTyped(json, false);
}

export function RenewalStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenewalStatus {
    return json as RenewalStatus;
}

export function RenewalStatusToJSON(value?: RenewalStatus | null): any {
    return value as any;
}

